module.exports = __webpack_public_path__ + "img/help-icon-04.75cafd51.png";